export function getTranslation(lang: string): {
    downloadOurApp: string;
    guidingYouForward: string;
    languageSiteLink;
} {
    const translationStrings = {
        en: {
            downloadOurApp: 'Download our App',
            languageSiteLink: 'Sitio en Español',
            guidingYouForward: 'Guiding you forward',
            copied: 'Copied!',
            copyToClipboard: 'Copy to clipboard',

        },
        es: {
            downloadOurApp: 'Descargue nuestra Aplicación',
            languageSiteLink: 'English Site',
            guidingYouForward: 'Guiándole hacia el Futuro',
            copied: '¡Copiado!',
            copyToClipboard: 'Copiar al portapapeles',
        }
    }
    return translationStrings[lang];
}
